import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aciocean/a6'
import pathMap from 'src/paths/pathMap'

class AcioceanRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.ACIOCEAN_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.ACIOCEAN_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.ACIOCEAN_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.ACIOCEAN_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default AcioceanRoute
